<template>
  <div class="ul">
    <van-form @submit="onSubmit" label-align="right">
      <van-field
        v-model="form.customerName"
        name="姓名"
        label="姓名："
        placeholder="请输入您姓名"
      />
      <van-field
        v-model="form.customerPhone"
        type="number"
        name="手机号"
        label="手机号："
        placeholder="请输入您的手机号"
      />
      <van-field
        readonly
        clickable
        v-model="region"
        name="area"
        label="城市："
        placeholder="请选择您所在城市"
        @click="showArea = true"
      />
      <div>
        <van-button
          block
          type="info"
          native-type="submit"
          :style="{
            background: `url(${btnImg}) center center no-repeat`,
            'background-size': 'contain',
          }"
        ></van-button>
      </div>
    </van-form>

    <!-- 弹窗 -->
    <van-popup v-model="showArea" position="bottom">
      <van-area
        title="请选择"
        columns-num="2"
        :area-list="areaList"
        @confirm="onConfirm"
        @cancel="showArea = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { updateForLive } from "@/api/";
import { areaList } from "@vant/area-data";
const initForm = () => {
  return {
    customerName: "",
    customerPhone: "",
    province: "",
    city: "",
  };
};
export default {
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
    btnImg: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: initForm(),
      region: "",
      showArea: false,
      areaList,
    };
  },
  created() {
    const { phoneNumber, province, city, serviceId, id } = this.$route.query;
    this.form = {
      customerPhone: phoneNumber,
      createBy: phoneNumber,
      province,
      city,
      serviceId,
      id,
    };
    this.region = `${province} - ${city}`;
  },
  methods: {
    onConfirm(val) {
      this.showArea = false;
      this.form.province = val[0].name;
      this.form.city = val[1].name;
      this.region = `${val[0].name} - ${val[1].name}`;
    },
    onSubmit() {
      if (this.region.length === 2) {
        this.form.province = this.region[0];
        this.form.city = this.region[1];
      }
      const { customerName, customerPhone, province, city } = this.form;
      if (!customerName) {
        this.$dialog.alert({ message: "请填写您的姓名" });
        return;
      }
      if (!customerPhone) {
        this.$dialog.alert({ message: "请填写您的手机号码" });
        return;
      }
      if (!(province && city)) {
        this.$dialog.alert({ message: "请填写选择您的城市" });
        return;
      }
      /**
			参数名	是否必须	类型	说明
			ascriptionModular	是	int	所属模块ascriptionModular=10
			serviceId	是	String	第三方活动编号/ID
			serviceName	是	String	第三方活动标题/直播标题
			preUserId	是	String	分享者ID（导购账号）
			createBy	是	String	接受者ID/手机号码（消费者）格式必须是正整数
			createByName	是	String	接受者昵称/手机号码（消费者）
			createByPhone	是	String	接受者手机号（消费者）
			province	是	String	省份（消费者）
			city	是	String	城市（消费者）
		* */
      this.form.createBy = this.form.customerPhone;

      const { serviceId, id } = this.$route.query;
      updateForLive(this.form).then(() => {
        this.$dialog.alert({ message: "提交成功" });
        this.form = initForm();
        this.form.serviceId = serviceId;
        this.form.id = id;
        this.region = "";
      });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.van-cell) {
  margin-bottom: 10px;
  border-radius: 10px;
  &::after {
    display: none;
  }
}
:deep(.van-button) {
  height: 80px;
  border: none;
  border-radius: 10px;
}
.ul {
  .li {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 8rpx;
    color: #000000;
    margin-bottom: 30rpx;
    padding: 0rpx 20rpx;
    font-size: 24rpx;
    height: 80rpx;
  }
  .uni-input {
    height: 60rpx;
    line-height: 60rpx;
  }
  .submit {
    // margin-top: 60rpx;
    // background: url(https://derucci-app-obs.iderucci.com/consumer-admin-derucci/20230612/YnRuLjE2ODY1NDA2MDU2MzE=.png)
    //   center center no-repeat;
    width: 518rpx;
    height: 160rpx;
    background-size: contain;
    border: none;
    &::after {
      border: none;
    }
  }
}
</style>
